/**
 * useSelectedCp.ts — W45.2 shared CP highlight state
 *
 * Single source of truth for the cross-panel CP highlight in Command View.
 * When any panel (Helix, Tower, Galaxy) fires a CP click/hover, all three
 * panels read the same `selectedCp` value and apply their local highlight.
 *
 * Implementation: plain React context (no external deps).
 * Usage:
 *   const { selectedCp, setSelectedCp } = useSelectedCp();
 *
 * Brand: No exclamation points. No emojis. M-PACT hyphenated.
 * Bryan K. Short, Founder and CEO, Mi6 Group.
 */

import { createContext, useContext } from "react";

export interface SelectedCpContextValue {
  /** Currently highlighted CP number (1–10), or null if none. */
  selectedCp: number | null;
  setSelectedCp: (cp: number | null) => void;
}

export const SelectedCpContext = createContext<SelectedCpContextValue>({
  selectedCp: null,
  setSelectedCp: () => {},
});

/** Consume the shared CP highlight state. */
export function useSelectedCp(): SelectedCpContextValue {
  return useContext(SelectedCpContext);
}
